import React from 'react';
import PropTypes from 'prop-types';
import {TubeStandSMWide, TubeStandXLShort} from '../../Icons';
import {Image} from '@learningblocks/shared-components';
import {Utilities} from '@learningblocks/exp-constants';

const {PROTOCOL_LAB_APPARATUS} = Utilities;

export function TubeStand(props) {
  const getStandImage = () => {
    switch (props.type) {
      case PROTOCOL_LAB_APPARATUS.TUBE_STAND_XL_SHORT:
        return TubeStandXLShort;
      case PROTOCOL_LAB_APPARATUS.TUBE_STAND_SM_WIDE:
        return TubeStandSMWide;
      default:
        return '';
    }
  };

  return (
    <Image
      className={props.className}
      src={getStandImage()}
      alt={`Tube Stand: ${props.type}`}
    />
  );
}

TubeStand.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,
  /**
   * Type of Tube
   */
  type: PropTypes.oneOf(['TUBE_STAND_XL_SHORT', 'TUBE_STAND_SM_WIDE']),
};

TubeStand.defaultProps = {};
